import React from 'react';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class Destiny2IronBannerRankPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 1;
  static maxValue = 16;

  static getDefaultValue = () => [1, 16];

  static marks = {
    1: '1',
    4: '4',
    7: '7',
    10: '10',
    13: '13',
    16: '16',
  };

    render() {
      const {intl, collapsed, value, onChange} = this.props;

        return (
          <div>
            <div className="range-inputs">
              <div className="range-inputs__item">
                <RestrictedNumberInput
                  label={intl.formatMessage({id: 'section.product.level'})}
                  min={Destiny2IronBannerRankPicker.minValue}
                  max={Destiny2IronBannerRankPicker.maxValue}
                  value={value[0]}
                  onChange={newValue => onChange([
                  newValue,
                  value[1]
                    ])}
                />
              </div>

                <div className="range-inputs__divider"/>

                  <div className="range-inputs__item">
                    <RestrictedNumberInput
                      label={intl.formatMessage({id: 'section.product.wanted'})}
                      min={Destiny2IronBannerRankPicker.minValue}
                      max={Destiny2IronBannerRankPicker.maxValue}
                      value={value[1]}
                      onChange={newValue => onChange([
                        value[0],
                        newValue
                      ])}
                    />
                  </div>
                </div>

                {!collapsed && (
                  <div className="slider">
                    <VariableStepRange
                      className="rc-slider-destiny-leveling-iron"
                      step={1}
                      min={Destiny2IronBannerRankPicker.minValue}
                      max={Destiny2IronBannerRankPicker.maxValue}
                      marks={Destiny2IronBannerRankPicker.marks}
                      value={value}
                      onChange={onChange}
                    />
                  </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/destiny2/Destiny2IronBannerRank.js